import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link, useParams } from "react-router-dom";

import { AnchorComponent } from "../../../components/elements";
import { FloatCardComponent, ActivityCardComponent } from "../../../components/cards";
import PageLayout from "../../../layouts/PageLayout";
import { useValidation } from "../../../context/ValidationContext";
import axios from "axios";
import {
  Row,
  Col,
  Form,
  Select,
  Option,
  Table,
  Dropdown,
  DropdownButton,
  InputGroup,
  ProgressBar,
  Card,
  Button,
  Carousel,
  FloatingLabel
} from "react-bootstrap";
import {
  FaUserCircle,
  FaFileInvoiceDollar,
  FaHome,
  FaIdCard,
  FaCreditCard,
  FaBriefcaseMedical,
  FaShoppingBag,
  FaCarSide,
  FaCarrot,
  FaClipboardList,
  FaElementor,
  FaHouseUser,
  FaIndent,
  FaUpload
} from "react-icons/fa";
import { GiFactory } from "react-icons/gi";
import {
  RiLayoutHorizontalFill,
  RiArrowGoBackFill,
  RiSettings4Fill,
} from "react-icons/ri";
import { MdFamilyRestroom, MdNewReleases } from "react-icons/md";
import Swal from "sweetalert2";
import RescueUpload from "./RescueUpload";
import moment from "moment";


export default function UserProfilePage() {
  const { id: paramPersonId } = useParams();
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const { t } = useContext(TranslatorContext)
  const [people, setPeople] = useState([]);
  const [person_id, setPersonId] = useState(paramPersonId || null);
  const [loanForm, setLoanForm] = useState(false);
  const [buisnessForm, setBuisnessForm] = useState(false);
  const [family, setFamily] = useState({});
  const [rescueData, setRescueData] = useState({
    rescued_by: null,
    person_id: null,
    family_story: null,
  });

  const [dData, setdData] = useState([]);
  const [error, setError] = useState();
  const { validateImageDimensions } = useValidation();
  const initialFormState = {


    //rescue card

    cnic: "",
    name: "",
    org: "",
    phone: "",
    //loan file amount
    loan_file: { file: null, preview: null, img: null, amount: 0 },
    khatta_file: { file: null, preview: null, img: null, amount: 0 },
    medical_file: { file: null, preview: null, img: null, amount: 0 },
    food_file: { file: null, preview: null, img: null, amount: 0 },
    utility_file: { file: null, preview: null, img: null, amount: 0 },
    rent_file: { file: null, preview: null, img: null, amount: 0 },
    other_file: { file: null, preview: null, img: null, amount: 0 },
    transportation_file: { file: null, preview: null, img: null, amount: 0 },
    meal_file: { file: null, preview: null, img: null, amount: 0 },
    khatta_unpaid_invoice: { file: null, preview: null, img: null, amount: 0 },
    meal_file_rc: { file: null, preview: null, img: null, amount: 0 },
    medical_file_rc: { file: null, preview: null, img: null, amount: 0 },
    transportation_file_rc: { file: null, preview: null, img: null, amount: 0 },
    unpaid_loan_invoice: { file: null, preview: null, img: null, amount: 0 },
    utility_amount: { file: null, preview: null, img: null, amount: 0 },


    equipment_cost: 0,
    estimated_cost: 0,
    stock_amount: 0,
    another_details: "",

    //business types 

    business_donor: 0,
    business_type_id: 0,
    //loan amounts
    affidavit_amount: 0,
    est_loan_amount: 0,
    estimated_business_cost: 0,
    food_ration: 0,
    incentive: 0,
    khatta_amount: 0,
    loan_amount: 0,
    medical_amount: 0,
    other: 0,
    rent_amount: 0,
    transportation: 0,
    total_dollar: 0,
    total_pkr: 0,
    utility_amount: 0,
    scholarship_amount: 0,

    equipment_cost_file: { file: null, preview: null, img: null },
    business_img: { file: null, preview: null, img: null },
    business_cost: 0,
    family_with_business: { file: null, preview: null, img: null },
    y_link: { file: null, preview: null, img: null },
    affidavit: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    relocation_img: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    release_img: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    family_check_img: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    family_working_img: {
      file: null,
      preview: null,
      imgsrc: "",
    },

    img_1: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    img_2: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    img_3: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    img_4: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    img_5: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    img_6: {
      file: null,
      preview: null,
      imgsrc: "",
    },
    new_home_img: {
      file: null,
      preview: null,
      imgsrc: "",
    },



  }
  const [businessId, setBusinessId] = useState(null);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [donors, setDonors] = useState([]);
  const [formState, setFormState] = useState(initialFormState);

const handleFileChange = async (e, field, activeSection) => {
  const file = e.target.files[0];
  if (!file) return;

  // Local preview immediately
  const localPreview = URL.createObjectURL(file);
  setFormState((prev) => ({
    ...prev,
    [field]: { ...prev[field], file, preview: localPreview },
  }));

  // Prepare FormData
  const formData = new FormData();
  formData.append("file", file);
  formData.append("file_key", field);

  // Determine ID and model
  let id = null;
  let model = "";
  switch (activeSection) {
    case "family":
      id = family?.person?.id;
      model = "people";
      break;
    case "loan":
      id = family?.person?.loan?.id;
      model = "loan";
      break;
    case "pictures":
      id = family?.person?.id;
      model = "picture";
      break;
    case "business":
      id = family?.person?.business?.id;
      model = "business";
      formData.append("business_cost", formState.business_cost || 0);
      break;
    default:
      console.warn("Unknown section:", activeSection);
  }

  formData.append("id", id);
  formData.append("model", model);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/upload-images`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    const uploadedFilePath = response.data?.[field];

    // Build preview URL
    const serverPreview = uploadedFilePath
      ? `${process.env.REACT_APP_IMG_URL}/${uploadedFilePath}?t=${Date.now()}` // cacheBuster
      : localPreview;

    // Update formState with preview and preserve rotation
    setFormState((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        preview: serverPreview,
        rotation: prev[field]?.rotation || 0,
      },
    }));

    // Update family state without wiping existing data
    setFamily((prev) => {
      if (!prev?.person) return prev;
      const updatedPerson = { ...prev.person };

      if (activeSection === "loan" && updatedPerson.loan) {
        updatedPerson.loan[field] = uploadedFilePath;
      } else if (activeSection === "business" && updatedPerson.business) {
        updatedPerson.business[field] = uploadedFilePath;
      } else if (activeSection === "pictures") {
        updatedPerson[field] = uploadedFilePath;
      } else if (activeSection === "family") {
        updatedPerson[field] = uploadedFilePath;
      }

      return { ...prev, person: updatedPerson };
    });
  } catch (error) {
    console.error("Upload Failed:", error);
  }
};


  const handleCostChange = (e, field) => {
    setFormState((prevState) => ({
      ...prevState,
      [field]: e.target.value,
    }));
  };
  const business_id = 0;
  const handleIconClick = (field) => {
    // Trigger the hidden file input
    document.getElementById(`file-input-${field}`).click();
  };
  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + '/rescue-initial-data').then((res) => {
      setPeople(res.data.people)
      setBusinessTypes(res.data.business_types)
      setDonors(res.data.donors)
      console.log("business types :", res.data.business_types)
    });
  }, [])
  useEffect(() => {

    console.log("business types of th eperson: ", businessTypes);
    if (person_id) {
      handleChangeFamily(person_id);
    }

  }, [person_id]);




  const handleChangeFamily = (selectedId) => {
    setPersonId(selectedId);
    axios.get(`${process.env.REACT_APP_API_URL}/get-selected-for-rescue/${selectedId}`).then((res) => {
      if (res.data.success) {
        setFamily(res.data);
        setBusinessId(res.data.person?.business?.id || null);
        setBusinessTypes(res.data.business_types)
        setdData(res.data || []);
        setFormState(initialFormState)
        setFormState((prevState) => {
          // List of file and amount keys
          const fileKeys = [
            'loan_file',
            'khatta_file',
            'medical_file',
            'food_file',
            'utility_file',
            'rent_file',
            'other_file',
            'transportation_file'
          ];
          const amountKeys = [

            'loan_amount',
            'khatta_amount',
            'food_ration',
            'meal_amount',
            'utility_amount',
            'rent_amount',
            'other',
            'transportation',



          ];


          const updatedState = { ...prevState };


          if (res.data.success) {
            setFamily(res.data);
            setBusinessId(res.data.person?.business?.id || null);

            setFormState((prev) => ({
              ...prev,
              equipment_cost: res.data.person?.business?.equipment_cost || 0,
              stock_amount: res.data.person?.business?.stock_amount || 0,
              another_details: res.data.person?.business?.another_details || "",
              business_cost: res.data.person?.business?.business_cost || 0,
              affidavit_amount: res.data.person?.loan?.affidavit_amount || 0,
              est_loan_amount: res.data.person?.loan?.est_loan_amount || 0,
              food_ration: res.data.person?.loan?.food_ration || 0,
              incentive: res.data.person?.loan?.incentive || 0,
              khatta_amount: res.data.person?.loan?.khatta_amount || 0,
              loan_amount: res.data.person?.loan?.loan_amount || 0,
              medical_amount: res.data.person?.loan?.medical_amount || 0,
              other: res.data.person?.loan?.other || 0,
              rent_amount: res.data.person?.loan?.rent_amount || 0,
              transportation: res.data.person?.loan?.transportation || 0,
              total_dollar: res.data.person?.loan?.total_dollar || 0,
              total_pkr: res.data.person?.loan?.total_pkr || 0,
              utility_amount: res.data.person?.loan?.utility_amount || 0,
              scholarship_amount: res.data.person?.loan?.scholarship_amount || 0,
              estimated_business_cost: res.data.person?.loan?.estimated_business_cost || 0,
              est_loan_amount: res.data.person?.loan?.est_loan_amount || 0,
              cnic: res.data.person?.res_by?.cnic || "",
              name: res.data.person?.res_by?.name || "",
              org: res.data.person?.res_by?.org || "",
              phone: res.data.person?.res_by?.phone || "",
              business_type_id: res.data.person?.business?.business_type_id || "",
              business_donor: res.data.person?.business?.donor_id || "",
              estimated_cost: res.data.person?.business?.estimated_cost || 0,



            }));

            setRescueData((prevState) => ({
              ...prevState,
              family_story: res.data?.person?.family_story,
            }));
          }


          fileKeys.forEach((key, index) => {
            updatedState[key] = {
              ...prevState[key],
              amount: res.data.person?.loan?.[amountKeys[index]] || 0
            };
          });

          // updatedState['business_cost'] = res.data.person?.business?.equipment_cost;
          return updatedState;
        });

        setRescueData((prevState) => ({
          ...prevState,
          family_story: res.data?.person?.family_story,
        }));
      }
    })
  }

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    console.log("Changed:", name, value);


    if (type === "file") {
      const file = files[0];
      const previewUrl = file ? URL.createObjectURL(file) : null;

      setFormState((prev) => ({
        ...prev,
        [name]: { file, preview: previewUrl },
      }));
    }

    else {
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    // update rescue data for all types (optional)
    setRescueData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleSubmit = () => {
    if (!rescueData.rescued_by || !rescueData.rescue_date || !person_id) {
      Swal.fire({
        title: 'Error!',
        text: 'Please fill in the required fields.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    } else {

      axios.post(process.env.REACT_APP_API_URL + "/store-rescue-data", {
        person_id: person_id,
        rescue_date: rescueData.rescue_date,
        rescued_by: rescueData.rescued_by,
      }).then((res) => {
        if (res.data.success) {
          setFamily(res.data);
          setRescueData((prevState) => ({
            ...prevState,
            family_story: res.data?.person?.family_story,
          }));
        }
      });

    }
  }
  // error messages
  const errorMessages = () => {

    Swal.fire({
      title: 'Error!',
      text: 'Please fill in the required fields',
      icon: 'error',
      confirmButtonText: 'Ok'
    })
  };


  const fields = [
    { field: "affidavit", text: "Affidavit Image", icon: "receipt" },
    { field: "release_img", text: "Release Image", icon: "handshake" },
    { field: "new_home_img", text: "New Home Image", icon: "house" },
  ];
  const handleSubmitStory = () => {
    axios.post(process.env.REACT_APP_API_URL + "/store-rescue-data", {
      person_id: person_id,
      family_story: rescueData.family_story,

    }).then((res) => {
      if (res.data.success) {
        Swal.fire({
          title: 'Updated!',
          text: 'Family Story has been successfully updated!.',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
      }
    });
  }

  const handleSubmitBusiness = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/update-family-business`,
        {
          business_id: businessId,
          donor_id: formState.business_donor,
          estimated_cost: formState.estimated_cost,
          person_id: person_id,
          business_type_id: formState.business_type_id,
          equipment_cost: formState.equipment_cost,
          stock_amount: formState.stock_amount,
          another_details: formState.another_details,
        }


      );

      if (response.data.success) {
        Swal.fire({
          title: 'Success!',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'Ok'

        });
      }
    } catch (err) {
      Swal.fire({
        title: 'Error!',
        text: 'Something went wrong. Please try again.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      console.error("Error updating:", err);
    }
  };



  const calculateAge = (dob) => {
    if (!dob) return null; // Return null if no date is provided
    const age = moment().diff(moment(dob, "YYYY-MM-DD"), "years");
    return age;
  };
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className='mc-breadcrumb'>
              <h3 className="mc-breadcrumb-title"><i className="material-icons">family_restroom</i>  {t('Rescue Family')}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item"><Link to='/' className="mc-breadcrumb-link" style={{ color: "#077834" }}>{t('home')}</Link></li>

                <li className="mc-breadcrumb-item">{t('Rescue Family')}</li>
              </ul>
            </div>
          </div>
        </Col>
        {
          !person_id ? <Row>
            <Col className="col-md-12">
              <div className="mc-card">
                <p><b>Add Family Rescue Record by Selecting FSF ID.</b></p>
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="FSF - ID"
                >
                  <Form.Select
                    name="person_id"
                    value={person_id}
                    onChange={(e) => setPersonId(e.target.value)}
                  >
                    <option value="">Select...</option>
                    {people.map((person) => {
                      return <option key={person.id} value={person.id}>{person.f_number} | {person.cnic} |{person.beneficiary_name} </option>;
                    })}
                  </Form.Select>
                  {person_id ? "" :
                    <span className="c_error">
                      Please Select Family
                    </span>
                  }
                </FloatingLabel>
              </div>
            </Col>
            <hr />
          </Row> : ""
        }

        {
          person_id ? <>
            <Col xl={5}>
              <div className="mc-card">
                <div className="mc-card-header">
                  <h4 className="mc-card-title">{"Rescue Details"} {family?.person?.f_number}</h4>

                </div>
                <div className="mb-4">


                  {
                    family?.person?.rescue_date ?
                      <ul className="mc-user-metalist">
                        <li><i className="material-icons">event_available</i> Rescue Date: <span>{family?.person?.rescue_date}</span></li>
                        <li><i className="material-icons">badge</i> Rescued By : <span>{family?.person?.res_by?.name?.length > 20
                          ? `${family.person.res_by.name.slice(0, 20)}...`
                          : family?.person?.res_by?.name}</span></li>
                      </ul>


                      :

                      <Card className="p-3">
                        <Row>
                          <Form.Group

                            as={Col}
                            md="12"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Rescue Date"
                              className="mb-3"
                            >
                              <Form.Control

                                type="date"
                                onChange={handleChange}
                                name="rescue_date"
                                placeholder=""
                                value={rescueData.rescue_date}
                              />
                              {rescueData.rescue_date ? "" :
                                <span className="c_error">
                                  Please Enter Rescue Date
                                </span>
                              }
                            </FloatingLabel>

                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md="12"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Select Partner"
                              className="mb-3"
                            >
                              <Form.Select
                                onChange={handleChange}
                                name="rescued_by"
                                value={rescueData.rescued_by}
                                required
                              >
                                <option value={""}>Select...</option>
                                {family?.identifiers?.map((identifier) => (
                                  <option key={identifier.id} value={identifier.id}>
                                    {identifier.name} ({identifier.org})
                                  </option>
                                ))}
                              </Form.Select>
                              {rescueData.rescued_by ? "" :
                                <span className="c_error">
                                  Please Select Partner
                                </span>
                              }
                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="12"
                            controlId="validationCustom01"
                          >
                            <Button onClick={() => handleSubmit()} className="btn btn-success w-100">Submit</Button>
                          </Form.Group>
                        </Row>

                      </Card>
                  }

                </div>
              </div>
              <div className="mc-card">
                <div className="mc-card-header">
                  <h4 className="mc-card-title">Beneficiary Personal Details {family?.person?.f_number}</h4>


                </div>
                <div className="mc-user-group">
                  <div className="mc-user-profile">
                    <div className="mc-round-avatar md">
                      <img src={process.env.REACT_APP_IMG_URL + family?.person?.avatar || "images/avatar/01.webp"} alt="avatar" />
                    </div>
                    <div className="mc-duel-text md">
                      <h3 className="mc-duel-text-title">{family?.person?.beneficiary_name || "Beneficiary Name"}</h3>
                      <p className="mc-duel-text-descrip">{family?.person?.faith?.name}</p>
                    </div>
                  </div>
                  <div className="mb-4">
                    <h6 className="mc-divide-title mb-4">More Deatils  {family?.person?.f_number}</h6>
                    <ul className="mc-user-metalist">
                      <li><i className="material-icons">person</i> Beneficiary Name: <span>{family?.person?.beneficiary_name}</span></li>

                      <li><i className="material-icons">credit_card</i> CNIC: <span>{family?.person?.cnic}</span></li>
                      <li><i className="material-icons">phone_in_talk</i> Phone: <span>{family?.person?.mob}</span></li>

                      <li><i className="material-icons">cake</i> D-O-B: <span>{calculateAge(family?.person?.dob)}</span></li>

                      <li><i className="material-icons">map</i> Address: <span>{family?.person?.present_address}</span></li>

                      <li><i className="material-icons">calendar_today</i> Slavery Years: <span>{family?.person?.slavery_years}</span></li>

                      <li><i className="material-icons">error_outline</i> Slavery Reason: <span>{family?.person?.slavery_reason?.name}</span></li>

                      <li><i className="material-icons">wc</i> Marital Status: <span>{family?.person?.marital_status?.name}</span></li>

                      <li><i className="material-icons">work</i> Occupation: <span>{family?.person?.occupation?.name || "N/A"}</span></li>


                      <li><i className="material-icons">check_circle_outline</i> Baptized: <span>{family?.person?.baptized ? "Yes" : "No"}</span></li>

                      <li><i className="material-icons">home</i> Brik Kiln: <span>{family?.person?.brick_kiln?.brickkiln_name}</span></li>
                      <li>


                        <Card className="rounded">
                          <img className="nic" src={process.env.REACT_APP_IMG_URL + family?.person?.cnic_f_img} alt="cnic_f_img" />
                        </Card>

                      </li>
                      <li>
                        <Card className="rounded">
                          <img className="nic" src={process.env.REACT_APP_IMG_URL + family?.person?.cnic_f_img} alt="cnic_f_img" />
                        </Card>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>

            <RescueUpload
              family={family ? family : null}

              fields={fields}
              formState={formState}
              setFormState={setFormState}
              businessTypes={businessTypes}
              donors={donors}
              rescueData={rescueData}
              handleFileChange={handleFileChange}
              handleCostChange={handleCostChange}
              handleChange={handleChange}
              handleSubmit={handleSubmitStory}
              handleSubmitBusiness={handleSubmitBusiness}

            />

            <Col xl={12}>
              <div className="mc-card">
                <Col xl={12}>
                  <h5 className="mc-divide-title mt-5 mb-4">Family Details</h5>


                  <Row>
                    <Col md={4}>
                      <h6 className="mc-divide-title mb-4">   <i className="material-icons">girl</i> Spouse Information</h6>

                      <div className="mc-product-view-meta mb-2">
                        <i className="material-icons">supervised_user_circle</i>
                        <h5>Gender</h5>
                        <span>:</span>
                        {family?.gender_id == 1 ? "Female" : "Male"}
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">girl</i>
                        <h5>Name:</h5>
                        <span>:</span>
                        {family?.person?.family?.spouse_name || "NOT Provided "}
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_today</i>
                        <h5>Age</h5>
                        <span>:</span>
                        {calculateAge(family?.person?.family?.spouse_dob)}
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_view_month</i>
                        <h5>Slavery Years</h5>
                        <span>:</span>
                        {family?.person?.family?.spouse_slavry_year} Years
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">credit_card</i>
                        <h5>CNIC</h5>
                        <span>:</span>
                        <span className="font-12"> {family?.person?.family?.spouse_cnic}</span>
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">monitor_heart</i>
                        <h5>Alive</h5>
                        <span>:</span>
                        {family?.person?.family?.spouse_is_dead == 0 ? "Yes" : "No"}
                      </div>
                    </Col>

                    <Col md={4}>
                      <h6 className="mc-divide-title mb-4"> <i className="material-icons">person_4</i> Father Information</h6>
                      <div className="mc-product-view-meta mb-2">
                        <i className="material-icons">supervised_user_circle</i>
                        <h5>Gender</h5>
                        <span>:</span>
                        Male
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">boy</i>
                        <h5>Name:</h5>
                        <span>:</span>
                        {family?.person?.family?.father_name}
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_today</i>
                        <h5>Age</h5>
                        <span>:</span>
                        {calculateAge(family?.person?.family?.father_dob)} Years
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_view_month</i>
                        <h5>Slavery Years</h5>
                        <span>:</span>
                        {family?.person?.family?.father_slavry_years} Years
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">credit_card</i>
                        <h5>CNIC</h5>
                        <span>:</span>
                        <span className="font-12">{family?.person?.family?.father_cnic}</span>
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">monitor_heart</i>
                        <h5>Alive</h5>
                        <span>:</span>
                        {family?.person?.family?.father_is_dead == 0 ? "Yes" : "No"}
                      </div>

                    </Col>

                    <Col md={4}>
                      <h6 className="mc-divide-title mb-4"> <i className="material-icons">person_3</i> Mother Information</h6>
                      <div className="mc-product-view-meta mb-2">
                        <i className="material-icons">supervised_user_circle</i>
                        <h5>Gender</h5>
                        <span>:</span>
                        Female
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">girl</i>
                        <h5>Name:</h5>
                        <span>:</span>
                        {family?.person?.family?.mother_name}
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_today</i>
                        <h5>Age</h5>
                        <span>:</span>
                        {calculateAge(family?.person?.family?.mother_dob)} Years
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">calendar_view_month</i>
                        <h5>Slavery Years</h5>
                        <span>:</span>
                        {family?.person?.family?.mother_slavry_years} Years
                      </div>
                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">credit_card</i>
                        <h5>CNIC</h5>
                        <span>:</span>
                        <span className="font-12">{family?.person?.family?.mother_cnic}</span>
                      </div>

                      <div className="mc-product-view-meta  mb-2">
                        <i className="material-icons">monitor_heart</i>
                        <h5>Alive</h5>
                        <span>:</span>
                        {family?.person?.family?.mother_is_dead == 0 ? "Yes" : "No"}
                      </div>

                    </Col>
                  </Row>
                </Col>
                <Col xl={12} className="mt-5">
                  <h5 className="mc-divide-title mb-4">{"Children's Detail"}</h5>

                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Age</th>
                        <th>CNIC</th>
                        <th>Slavery Years</th>
                        <th>School Going</th>

                        <th>Training Refer</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        family?.person?.childrens?.map((kid, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{kid.name}</td>
                              <td>{calculateAge(kid.dob)}</td>
                              <td>{kid.cnic}</td>
                              <td>{kid.slavery_years}</td>
                              <td>{kid.school_going == 1 ? "Yes" : "No"}</td>
                              <td>{kid.vocational_center == 1 ? "Yes" : "No"}</td>
                            </tr>
                          )
                        })

                      }


                    </tbody>
                  </Table>


                </Col>
                <Col xl={12} className="mt-5">
                  <h5 className="mc-divide-title mb-4">{"Kin's Detail"}</h5>

                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Relation</th>
                        <th>Name</th>
                        <th>Age</th>
                        <th>CNIC</th>
                        <th>Slavery Years</th>

                      </tr>
                    </thead>
                    <tbody>
                      {
                        family?.person?.kins?.map((kin, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{kin.relation?.name}</td>
                              <td>{kin.name}</td>
                              <td>{calculateAge(kin.dob)}</td>
                              <td>{kin.cnic}</td>
                              <td>{kin.slavery_years}</td>
                            </tr>
                          )
                        })

                      }
                    </tbody>
                  </Table>
                </Col>
              </div>
            </Col>
          </> : ""
        }

      </Row>
    </PageLayout>
  )
}